<template>
    <div class="field field--zipcode" :class="fieldClasses">
        <div class="row collapse no-pad align-middle" v-if="helptext || label">
            <div class="columns shrink" v-if="helptext">
                <help-text :helptext="helptext"></help-text>
            </div>
            <div class="columns" v-if="label">
                <label :class="labelClasses">{{ label }}</label>
            </div>
        </div>
        <div class="row">
            <div class="columns">
                <input
                    type="number"
                    :value="value"
                    @input="updateValue"
                    :placeholder="placeholder">
            </div>
        </div>
        <div class="row" v-if="hasErrors">
            <div class="columns">
                <ul class="field__errors">
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Component Dependencies
     */
    import BaseField from './BaseField'
    import HelpText from '../HelpText'

    /**
     * Zipcode Form Component
     */
    export default {
        name: 'zipcode_field',
        extends: BaseField,
        components: {
            HelpText
        },
        computed: {
            isValid () {
                return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(this.value)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/forms/ZipcodeField.vue